import React, { useState } from 'react';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import { handleSubmit } from '../apis/dataService';

const ComplaintForm = () => {
    // IMPORT USERNAME FROM LOCALSTORAGE:
    const { GetUsername } = useAccount();


    // SET COMPLAIN INITIAL VALUE AND VALUE ONCHANGE:
    const [complaint, setComplaint] = useState('');
    const handleComplaintChange = (event) => {
        setComplaint(event.target.value);
    };


    const handleformSubmit = (event) => {
        const thanks = document.getElementById('thanksforbuying-id');
        handleSubmit({
            event: event,
            username: GetUsername(),
            h1: 'Complain',
            data1: complaint,
            api: 'complain-form'
        });
        setComplaint('')
        thanks.style.display = 'flex';
        thanks.classList.add('show');

        // Remove the 'show' class after 2 seconds
        setTimeout(function () {
            thanks.classList.remove('show');
        }, 4000);
    }

    return (
        <div className="complain-form">
            <h1 className="complain-header">COMPLAINT FORM</h1>
            <form onSubmit={handleformSubmit} className="complain-form-container">
                <div className="complain-form-group">
                    <label className="complain-label">Username:</label>
                    <span className="complain-username">{GetUsername()}</span>
                </div>
                <div className="complain-form-group">
                    <label className="complain-label">Complaint:</label>
                    <textarea
                        value={complaint}
                        onChange={handleComplaintChange}
                        placeholder="Enter your complaint..."
                        required
                        className="complain-textarea"
                    />
                </div>
                <button type="submit" className="complain-submit-button">
                    Submit Complaint
                </button>
                <div className="thanksforbuying" id='thanksforbuying-id'>
                    <p>
                        "Thank you for reaching out. We've received your complaint and our team will review it promptly. You’ll hear back from us soon."
                    </p>
                </div>
            </form>
        </div>


    );
};

export default ComplaintForm;